import {
  ComponentStateManager,
  DataVizContainerCommonUtils,
} from '../../../common/types';
import {
  TimePeriodUnsegmentedVizData,
  TimePeriodUnsegmentedVizExternalProps,
} from '../../types';
import { getChartDataFromTimePeriodUnsegmentedResponse } from '../common/common-utils';
import {
  TimePeriodUnsegmentedBarChartActions,
  TimePeriodUnsegmentedBarChartState,
  TimePeriodUnsegmentedBarChartUiComponentProps,
} from './types';

export const timePeriodUnsegmentedBarChartDataToUiComponentProps = (
  data: TimePeriodUnsegmentedVizData,
  externalProps: TimePeriodUnsegmentedVizExternalProps,
  componentStateManager: ComponentStateManager<
    TimePeriodUnsegmentedBarChartState,
    TimePeriodUnsegmentedBarChartActions
  >,
  { dataFieldValueFormatter }: DataVizContainerCommonUtils
): TimePeriodUnsegmentedBarChartUiComponentProps => {
  const { fullScreenHandle, preferences } = externalProps;
  const { dataResponse, titleConfig, metricDetails, metricDisplayValues } =
    data;
  const chartData = getChartDataFromTimePeriodUnsegmentedResponse(
    dataResponse,
    preferences,
    metricDetails,
    metricDisplayValues,
    dataFieldValueFormatter
  );
  const displayConfig = {
    ...componentStateManager.state.displayState,
    ...componentStateManager.actions.displayActions,
  };
  return {
    fullScreenHandle,
    displayConfig,
    titleConfig,
    chartData,
    chartColors: data.chartColors,
  };
};
